import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import api from "@helpers/api";
import { adaptMyEnrollmentDetail } from "../../helpers/apiAdapters";

/**
 * One subscribed mentoring (§6.11 single). Reads :enrollmentId from the route,
 * fetches the full MyEnrollmentDetail (#17), and surfaces a notFound flag for
 * the 404 empty state. refresh() re-fetches (used after attach in §6.10).
 */
export default function useMyMentoringDetail() {
  const { enrollmentId } = useParams();

  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);

  const requestRef = useRef(0);

  useEffect(() => {
    if (!enrollmentId) return;

    const requestId = ++requestRef.current;
    setLoading(true);
    setNotFound(false);

    (async () => {
      const res = await api.get(`mentoring/my-enrollments/${enrollmentId}`);
      if (requestId !== requestRef.current) return;

      if (res?.response) {
        setEnrollment(null);
        setNotFound(true);
      } else {
        const detail = adaptMyEnrollmentDetail(res?.data);
        setEnrollment(detail);
        setNotFound(!detail);
      }
      setLoading(false);
    })();
  }, [enrollmentId, reloadToken]);

  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  return { enrollment, loading, notFound, refresh };
}
